import { PaxPrice, PriceDetailGeneric } from "@ssc-booking/api-contracts"
import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import * as ROA from "fp-ts/ReadonlyArray"

import { i18n } from "@lingui/core"
import { paxRow, ReceiptSection } from "../types"
import { guestLabel, isDiscount } from "./utils"

export type GenericLabels = Record<PriceDetailGeneric["category"], string>

export const genericPromotionsToReceiptSections =
    (labels: GenericLabels) =>
    (paxPrice: PaxPrice): readonly ReceiptSection[] =>
        F.pipe(
            //keep new line
            paxPrice.details.others,
            ROA.map(genericPromotionToReceiptSection(labels, paxPrice.number)),
        )

const genericPromotionToReceiptSection =
    (labels: GenericLabels, paxNumber: number) =>
    (promo: PriceDetailGeneric): ReceiptSection => ({
        label: i18n._(labels[promo.category]),
        key: promo.category,
        isPromotional: isDiscount(promo.amount),
        totalAmount: O.some(promo.amount),
        rows: [paxRow({ label: guestLabel(paxNumber), isPromotional: isDiscount(promo.amount), amount: O.some(promo.amount) })],
    })
